import React, { Component } from 'react'
import DocumentMeta from 'react-document-meta';
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import './visualizer.css'
import { LicenseContainer } from './Disclaimers/License/License'
import { Rectangle } from '../../helpers/math'
import { MediaContainer } from './Media/Media'
import { AppBarContainer } from './AppBar/AppBar'
import { ErrorContainer } from './Notifications/Error/Error'
import { TopBarContainer } from './TopBar/TopBar'
import { AlertsContainer } from './Notifications/Alerts/Alerts'
import { BottomBarContainer } from './BottomBar/BottomBar'
import { Analytics } from './Analytics/Analytics'

class Visualizer extends Component {

    static propTypes = {
        navigation: PropTypes.object.isRequired,
        title: PropTypes.object.isRequired,
        mediaOriginalLocation: PropTypes.string,
        twitterId: PropTypes.string,
        description: PropTypes.string,
        listenKeyboardEvents: PropTypes.func.isRequired,
    }

    componentDidMount()
    {
        document.addEventListener("keyup", this.props.listenKeyboardEvents)
    }

    componentWillUnmount()
    {
        document.removeEventListener("keyup", this.props.listenKeyboardEvents)
    }

    buildMeta = () => {
        const { title, mediaOriginalLocation, twitterId, description } = this.props
        const titleAsString = [title.recordTitle, title.referenceCode, title.appName].join(' - ')
        const meta = {
            title: titleAsString,
            description,
            meta: {
                property: {
                    'og:title': titleAsString,
                    'og:description': description,
                    'og:image': mediaOriginalLocation,
                    'og:site_name': title.appName,
                }
            }
        }

        if(twitterId !== null)
        {
            meta.meta.property['twitter:site'] = `@${twitterId}`
        }

        return meta
    }

    render()
    {
        return (
            <DocumentMeta {...this.buildMeta()}>
                <Analytics>
                    <div className="container">
                        <TopBarContainer />
                        <div className="visualizer">
                            <AppBarContainer />
                            <div ref={(node) => this.mediaParentRef = node} className="media-wrapper">
                                {this.mediaParentRef && <MediaContainer frame={Rectangle.createFromElement(this.mediaParentRef)} />}
                            </div>
                        </div>
                        <BottomBarContainer />
                        <LicenseContainer />
                        <ErrorContainer />
                        <AlertsContainer />
                    </div>
                </Analytics>
            </DocumentMeta>
        )
    }
}

export default withTranslation()(Visualizer)
